import { StsNotification } from'./sts-notification.model';
export class Question {
    id: string;
    textEn: string;
    textFr: string;
    error: StsNotification;
}
